export default {
  LOAD_THEORETICAL_PART_OVERVIEW_PAGE_START: 'LoadTheoreticalPartOverviewPageStart',
  LOAD_THEORETICAL_PART_OVERVIEW_PAGE_END: 'LoadTheoreticalPartOverviewPageEnd',
  SELECT_THEORETICAL_PART_OVERVIEW_PAGE_TAB: 'SelectTheoreticalPartOverviewPageTab',
  CLEAR_THEORETICAL_PART_OVERVIEW_PAGE: 'ClearTheoreticalPartOverviewPage'
};